<div class="header-notification__float-block is-open--">
  <div class="header-notification__float-header">
    <div class="float-header__date">
      {{ "NOTIFICATION.TITLE" | translate }} ({{ unreadNotification$ | async }})
    </div>
    <div class="float-header__mark-all-read disabled--">
      <a> </a>
    </div>
  </div>
  <div class="header-notification__content-wrapper">
    <div class="header-notification__content">
      <div class="hn-content__welcome">
        <div class="hn-content__welcome-visual">
          @if (isEmptyNotifiList) {
            <div class="no-record">
              <img
                class="bell-size"
                src="./assets/img/Illustration - No notification.svg"
              />
              <h2 class="no-notifi">
                {{ "NOTIFICATION.NO_NOTIFICATIONS" | translate }}
              </h2>
            </div>
          }
          <div
            infinite-scroll
            [infiniteScrollDistance]="scrollDistance"
            [infiniteScrollThrottle]="throttle"
            [infiniteScrollContainer]="'.header-notification__content-wrapper'"
            [fromRoot]="true"
            [scrollWindow]="false"
            (scrolled)="onScrollDown($event)"
          >
            @if (messages?.length > 0) {
              @for (notification of messages; track notification) {
                <div
                  class="notification-card"
                  [ngClass]="getClass(notification.seenInd)"
                >
                  <div
                    class="notification-container"
                    (click)="notifClicked(notification)"
                    (keydown.enter)="notifClicked(notification)"
                    tabindex="0"
                    role="button"
                  >
                    <div>
                      <nx-icon
                        [ngClass]="getIcon(notification)"
                        class="icon-notif"
                        size="m"
                      ></nx-icon>
                    </div>
                    <div class="notification-title-body">
                      <p class="notification-title">
                        {{ toCamelCase(notification.title) }}
                      </p>
                      <p class="notification-title-date">
                        {{ notification.updateDate }}
                      </p>
                    </div>
                  </div>
                  <div class="notification-body">
                    {{ notification.message }}
                  </div>
                </div>
              }
            }
            @if (isLoading) {
              <div
                class="spinner-height"
                [ngClass]="
                  scrolledDown ? 'loading-container' : 'loading-container-top'
                "
              >
                <nx-spinner size="large"></nx-spinner>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
